import * as React from 'react';
import NewsCard from '../NewsCard';
import NewsCardProps from '../NewsCard/type';
import './styles.scss';

const FeaturedArticleCard = ({
  category,
  title,
  date,
  thumbnail,
  type,
  url,
  viewMoreLink,
}: NewsCardProps) => (
  <div className="featured-news-card">
    <NewsCard
      category={category}
      title={title}
      date={date}
      thumbnail={thumbnail}
      type={type}
      url={url}
      viewMoreLink={viewMoreLink}
    />
  </div>
);

export default FeaturedArticleCard;
